(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["novriso-cleaning-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('novriso-product-carousel')) {
  customElements.define('novriso-product-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.viewport = this.querySelector('.ncm-window');
      this.group = this.querySelector('.ncm-group');
      this.pauseButton = this.querySelector('[data-ncm-pause]');
      if (!this.viewport || !this.group || !this.pauseButton) return;
      this.ready = true;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.position = this.viewport.scrollLeft;
      this.distance = this.group.getBoundingClientRect().width;
      this.speed = Number(this.dataset.speed) || 30;
      this.visible = false;
      this.hovered = false;
      this.focused = false;
      this.setPaused(this.motion.matches);
      this.pauseButton.addEventListener('click', () => {
        this.position = this.viewport.scrollLeft;
        this.setPaused(!this.paused);
      }, options);
      this.querySelector('[data-ncm-previous]').addEventListener('click', () => this.step(-1), options);
      this.querySelector('[data-ncm-next]').addEventListener('click', () => this.step(1), options);
      this.viewport.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') this.hovered = true; }, options);
      this.viewport.addEventListener('pointerleave', () => { this.hovered = false; }, options);
      this.viewport.addEventListener('pointerdown', event => { if (event.pointerType !== 'mouse') this.setPaused(true); }, options);
      this.viewport.addEventListener('wheel', event => { if (Math.abs(event.deltaX) > 0 || event.shiftKey) this.setPaused(true); }, { ...options, passive: true });
      this.viewport.addEventListener('focusin', () => { this.focused = true; }, options);
      this.viewport.addEventListener('focusout', () => { this.focused = false; }, options);
      this.viewport.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.step(event.key === 'ArrowLeft' ? -1 : 1);
        }
      }, options);
      this.motion.addEventListener('change', event => { if (event.matches) this.setPaused(true); }, options);
      this.addEventListener('shopify:block:select', event => {
        this.setPaused(true);
        const card = event.target.closest('.ncm-card');
        if (card) this.viewport.scrollLeft = card.offsetLeft - this.group.offsetLeft;
      }, options);
      this.resizeObserver = new ResizeObserver(() => {
        this.distance = this.group.getBoundingClientRect().width;
        this.position = this.viewport.scrollLeft;
      });
      this.resizeObserver.observe(this.group);
      this.intersectionObserver = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; }, { threshold: 0.05 });
      this.intersectionObserver.observe(this);
      this.lastTime = null;
      const tick = time => {
        const elapsed = this.lastTime === null ? 0 : Math.min(time - this.lastTime, 50);
        this.lastTime = time;
        if (this.visible && !this.paused && !this.hovered && !this.focused && !document.hidden && this.distance > 0) {
          this.position = (this.position + this.speed * elapsed / 1000) % this.distance;
          this.viewport.scrollLeft = this.position;
        } else {
          this.position = this.viewport.scrollLeft;
        }
        this.frame = requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    }
    setPaused(paused) {
      this.paused = paused;
      this.toggleAttribute('data-paused', paused);
      this.pauseButton.setAttribute('aria-pressed', String(paused));
      this.querySelector('[data-ncm-pause-label]').textContent = paused ? this.dataset.play : this.dataset.pause;
      this.querySelector('.ncm-pause-icon').textContent = paused ? '▶' : 'Ⅱ';
    }
    step(direction) {
      this.setPaused(true);
      const card = this.group.querySelector('.ncm-card');
      if (!card || !this.distance) return;
      const gap = parseFloat(getComputedStyle(this.group).columnGap) || 0;
      const target = (this.viewport.scrollLeft + direction * (card.getBoundingClientRect().width + gap) + this.distance) % this.distance;
      this.viewport.scrollTo({ left: target, behavior: this.motion.matches ? 'instant' : 'smooth' });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      this.intersectionObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["novriso-cleaning-details"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (event) {
  var link = event.target.closest('.nd-page [data-nd-quantity]');
  if (!link) return;
  var quantity = link.getAttribute('data-nd-quantity');
  var input = document.querySelector('quantity-breaks input[type="radio"][name="quantity"][value="' + quantity + '"]');
  if (!input) return;
  event.preventDefault();
  input.click();
  var purchase = input.closest('quantity-breaks');
  purchase.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center'});
  input.focus({preventScroll: true});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["novriso-cleaning-news"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('novriso-journal')) {
  class NovrisoJournal extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.chapters = [...this.querySelectorAll('[data-nj-chapter]')];
      this.links = [...this.querySelectorAll('[data-nj-link]')];
      this.progress = this.querySelector('[data-nj-progress]');
      this.content = this.querySelector('.nj-content');
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.updateReading(); });
      };
      window.addEventListener('scroll', this.schedule, {passive: true, signal: this.controller.signal});
      window.addEventListener('resize', this.schedule, {passive: true, signal: this.controller.signal});
      this.updateReading();
    }
    updateReading() {
      if (!this.content || !this.chapters.length) return;
      let active = this.chapters[0].id;
      for (const chapter of this.chapters) {
        if (chapter.getBoundingClientRect().top <= Math.max(240, innerHeight * .35)) active = chapter.id;
      }
      for (const link of this.links) {
        if (link.hash === '#' + active) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      }
      const rect = this.content.getBoundingClientRect();
      const progress = Math.max(0, Math.min(1, (innerHeight - rect.top) / (rect.height + innerHeight)));
      if (this.progress) this.progress.style.transform = 'scaleX(' + progress + ')';
    }
    disconnectedCallback() {
      this.controller?.abort();
      cancelAnimationFrame(this.frame);
      this.frame = null;
    }
  }
  customElements.define('novriso-journal', NovrisoJournal);
}


  } catch(e) { console.error(e); }
})();
})();
